const mPaginatePrimary = {
  mPaginatePrimary: {
    messagesPages: {
      first: 'Primero',
      following: 'Siguiente',
      last: 'Último',
      previous: 'Anterior'
    },

    messagesQuantity: {
      showing: 'Mostrando',
      of: 'de',
      results: 'resultados'
    }
  }
}

export default mPaginatePrimary
